import { getEasiplusFuneralPlan } from "./index";
import { createSelector } from "reselect";

export const getThankYou = createSelector(
    getEasiplusFuneralPlan,
    easiplusFuneralPlan => easiplusFuneralPlan.thankYou
);

export const getReferenceNumber = createSelector(
    getThankYou,
    thankYou => thankYou && thankYou.referenceNumber,
);

export const getFirstNames = createSelector(
    getThankYou,
    thankYou => {
        if(thankYou){
            return thankYou.firstNames
        }
    },
);